// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-index-tsx": () => import("./../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-default-swiggle-tsx": () => import("./../src/templates/default-swiggle.tsx" /* webpackChunkName: "component---src-templates-default-swiggle-tsx" */),
  "component---src-templates-default-tsx": () => import("./../src/templates/default.tsx" /* webpackChunkName: "component---src-templates-default-tsx" */)
}

